import Vue from 'vue';

export default {
    init() {
        window.eventHub = new Vue();
    },
};
